import { useGetFTUXHomeTakeoverFlowQuery } from "../../services/ftuxService";
import { useAuthStore } from "stores/auth.store";

const FTUXBootstrapper = () => {
  const { isLoggedIn } = useAuthStore();
  useGetFTUXHomeTakeoverFlowQuery(undefined, {
    refetchOnFocus: false,
    refetchOnReconnect: false,
    pollingInterval: 0,
    skip: !isLoggedIn,
  });
  return null;
};

export default FTUXBootstrapper;
